
define('template!customersDetailBodyProfileAddressesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="invoice-region region"></div>\n<div class="delivery-region region"></div>';

}
return __p
};});

